import { SuperModel } from './super-model.model';
import { RouteLog } from './route-log.model';
import { ERouteType } from '@enums';

export class RouteLogSummary extends SuperModel {
  startEventTime: Date | string;
  endEventTime: Date | string;
  startedAt?: Date | string;
  finishedAt?: Date | string;
  type?: ERouteType;
  driverInfo?: string;
  busInfo?: string;
  routePlanInfo?: string;
  childrenListInfo?: string;
  numOfPickUpChildren: number;
  numOfDropOffChildren: number;
  numOfAbsentChildren: number;
  numOfChildrenInBusAtStart: number;
  numOfChildrenNotInBusAtStart: number;
  numOfChildrenInBusAtEnd: number;
  numOfChildrenNotInBusAtEnd: number;
  startLocationLatitude?: number;
  startLocationLongitude?: number;
  endLocationLatitude?: number;
  endLocationLongitude?: number;
  startLocationLink?: string;
  endLocationLink?: string;
  routeLogs?: RouteLog[];

  get validEndTime(): Date | null {
    const end = this.toDate(this.endEventTime);
    if (!end || isNaN(end.getTime()) || end.getFullYear() < 1970) {
      return null;
    }
    return end;
  }

  get spansMultipleDays(): boolean {
    const start = this.toDate(this.startEventTime);
    const end = this.validEndTime;
    if (!start || !end) {
      return false;
    }
    return (
      start.getFullYear() !== end.getFullYear() ||
      start.getMonth() !== end.getMonth() ||
      start.getDate() !== end.getDate()
    );
  }

  constructor(data: any = {}) {
    super(data);
    this.type = RouteLogSummary.normalizeRouteType(data.type);
    if (data.startEventTime) {
      this.startEventTime = new Date(data.startEventTime);
    }
    if (data.endEventTime) {
      this.endEventTime = new Date(data.endEventTime);
    }
    if (data.startedAt) {
      this.startedAt = new Date(data.startedAt);
    }
    if (data.finishedAt) {
      this.finishedAt = new Date(data.finishedAt);
    }
    if (data.routeLogs) {
      this.routeLogs = data.routeLogs.map((log: any) => new RouteLog(log));
    }
  }

  get serialised() {
    return {
      id: this.id,
      type: this.type,
      startEventTime: this.startEventTime,
      endEventTime: this.endEventTime,
      startedAt: this.startedAt,
      finishedAt: this.finishedAt,
      driverInfo: this.driverInfo,
      busInfo: this.busInfo,
      routePlanInfo: this.routePlanInfo,
      childrenListInfo: this.childrenListInfo,
      numOfPickUpChildren: this.numOfPickUpChildren,
      numOfDropOffChildren: this.numOfDropOffChildren,
      numOfAbsentChildren: this.numOfAbsentChildren,
      startLocationLatitude: this.startLocationLatitude,
      startLocationLongitude: this.startLocationLongitude,
      endLocationLatitude: this.endLocationLatitude,
      endLocationLongitude: this.endLocationLongitude,
      startLocationLink: this.startLocationLink,
      endLocationLink: this.endLocationLink,
      routeLogs: this.routeLogs && this.routeLogs.map(log => log.serialised),
    };
  }

  private static normalizeRouteType(value?: string): ERouteType | undefined {
    if (!value) {
      return undefined;
    }
    const normalized = String(value)
      .toUpperCase()
      .replace(/-/g, '_');
    if (normalized === ERouteType.TO_SCHOOL || normalized === ERouteType.FROM_SCHOOL) {
      return normalized as ERouteType;
    }
    return undefined;
  }

  private toDate(value?: Date | string): Date | null {
    if (!value) {
      return null;
    }
    return value instanceof Date ? value : new Date(value);
  }
}
